import React, { Component } from "react";
import { FaWallet, FaMoneyBillWave } from "react-icons/fa";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import TableComp from "../../../components/_utils/table";
import {
  Button,
  Card,
  DatePicker,
  Row,
  Col,
  notification,
  Select,
  Icon,
  Tooltip,
  Popconfirm,
} from "antd";
import Request from "../../../request";
import { connect } from "react-redux";
import _ from "lodash";
import styles from "./styles.less";
import moment from "moment";
import common from "../../common.less";
import { RightsWrapper } from "../../../components/_utils/utils";
import Settings from "../../../components/_utils/settings";
import lodash from "lodash";
import { CSVLink } from "react-csv";

const Option = Select.Option;
const { RangePicker } = DatePicker;

const incentiveType = {
  DIRECT_TO_DIRECT: "Direct to Direct",
  DIRECT_TO_CP: "Direct to CP",
  AP_TO_DIRECT: "AP to Direct",
  AP_TO_CP: "AP to CP",
};

const financeUserGroup = "62e238043f0d23080edafeaf";

class IncentiveDesk extends Component {
  state = {
    count: 0,
    countryArr: [],
    users: [],
    universities: [],
    invoiceUsers: [],
    typeArr: [
      { id: "VISA_UNDER_PROCESSING", display: "Visa Under Processing" },
      { id: "VISA_APPROVED", display: "Visa Approved" },
      { id: "VISA_REJECTED", display: "Visa Rejected" },
      { id: "INVOICE_UNDER_REVIEWED", display: "Invoice Under Reviewed" },
      { id: "INVOICE_PAYMENT_DESK", display: "Invoice Payment Desk" },
      { id: "INVOICE_PAID", display: "Invoice Paid" },
    ],

    stagestypeArr: [
      { id: "TELECALLER", display: "Telecaller" },
      { id: "COUNSELLING", display: "Counselling" },
      { id: "ADMISSION", display: "Admission" },
      { id: "VISA FILE", display: "Visa File" },
      { id: "VISA APPROVED", display: "Visa Approved" },
    ],

    inquiryType: [
      { id: "STUDENT", display: "Student" },
      { id: "VISITOR", display: 'Visitor' }
    ],

    statusArr: [
      { id: "Waiting", display: "Waiting" },
      { id: "Approved", display: "Approved" },
      {id:'Invoice Under Review', display:'Invoice Under Review'},
      {id:'Paid', display:'Paid'},
      {id:'Unpaid', display:'Unpaid'}
    ],

    incentiveTypeArr: [
      { id: "DIRECT_TO_DIRECT", display: "Direct to Direct" },
      { id: "DIRECT_TO_CP", display: "Direct to CP" },
      { id: "AP_TO_DIRECT", display: "AP to Direct" },
      { id: "AP_TO_CP", display: "AP to CP" },
    ],

    atLevels: [
      { name: "Counselling Desk", value: "Front Desk" },
      { name: "Dead Inquiry", value: "Dead Inquiry" },
      { name: "Registration Desk", value: "Registration Desk" },
      { name: "Deleted", value: "Deleted" },
      { name: "Visa Desk", value: "Visa Desk" },
      { name: "Application Desk", value: "Application Desk" },
      { name: "Claim Desk", value: "Claim Desk" },
    ],

    walletTypeArr: [
      { id: 'Waiting', display: 'Waiting' },
      { id: 'Invoice Under Review', display: 'Invoice Under Review' },
      { id: 'Approved', display: 'Approved' },
      {id:'Paid', display:'Paid'},
      {id:'Unpaid', display:'Unpaid'}
    ],
    time: {
      key: "createdByUser.time",
      from: null,
      to: null,
    },
    loading: false,
    records: [],
    monthArrayForInvoice: [],
    user: "",
    userId: "",
    universityId: "",
    walletAmount: 0.0,
    approvedAmount:0.0,
    disburseAmount: 0.0,
    paidAmount: 0.0,
    rejectedAmount: 0.0,
    institutionalIncentive: 0.0,
    disburseIncentiveAmount: 0.0,
    invoiceUnderReviewedAmount: 0.0,
    localUser: {},
    selectedUserId: "",
    isUserDDView: false,
    exportParams: null,
    hideInvoiceButton: false,
    FinanceStatusOptions: [
      { id: "INVOICE_UNDER_REVIEWED", display: "Invoice Under Reviewed" },
      { id: "INVOICE_PAYMENT_DESK", display: "Invoice Payment Desk" },
    ],
  };
  searchParams = new URLSearchParams(window.location.search);

  constructor(props) {
    super(props);
    this.table = React.createRef();
    this.exportRef = React.createRef();
  }


  getCurrentUser = () => {
    let user = JSON.parse(localStorage.getItem('user'))
    if (user.incentiveTerm === "Monthly") {
      this.setState({ monthArrayForInvoice: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], localUser: user })
    } else if (user.incentiveTerm === "Quaterly") {
      this.setState({ monthArrayForInvoice: [0, 3, 6, 9], localUser: user })
    } else if (user.incentiveTerm === "Half-Yearly") {
      this.setState({ monthArrayForInvoice: [0, 6], localUser: user })
    } else if (user.incentiveTerm === "Yearly") {
      this.setState({ monthArrayForInvoice: [0], localUser: user })
    } else {
      this.setState({ monthArrayForInvoice: [0, 3, 6, 9], localUser: user });
    }
  }

  async componentDidMount() {
    this.getCurrentUser()
    let userId = this.searchParams.get("userId");
    let status = this.searchParams.get("status");
    if (userId && status) {
      if(status === "Approved") {
        this.setState({
          userId: userId,
          walletId: 'Unpaid'
        });
      }else if (status === "Paid") {
        this.setState({
          userId: userId,
          walletId: 'Paid'})
      }else {
        this.setState({
          userId: userId,
          walletId: 'Invoice Under Review'
        });
      }
    }

    if (!this.searchParams.get("id")) {
      this.loadUsers();
    }
    this.loadInvoiceUsers();
    this.loadCountry();
    this.loadUniversities();
  }

  apiIncentiveRequest = (params) => {
    return new Promise(async (resolve) => {
      if (this.state.userId) {
        params.userId = this.state.userId;
      }
      if (this.state.universityId) {
        params.universityId = this.state.universityId;
      }
      if (this.searchParams.get("id")) {
        params.studentId = this.searchParams.get("id");
      }
      if (params.countryId && params.countryId.length) {
        const countryId = this.state.countryArr.find(
          (country) =>
            country.text.toLowerCase() === params.countryId[0].toLowerCase()
        );
        params.countryId = countryId ? countryId.value : params.countryId;
      }
      if (this.state.walletId) {
        params.status = this.state.walletId
      }
      if (this.state.time.from) {
        params.time = this.state.time
      }
      const payload = {
        ...params,
        regExFilters: [
          "applicantName",
          "studentName",
          "userName",
          "channelPartnerName",
        ],
      };

      let response = await Request.getAllIncentiveDetails(params)
      this.setState({ count: response.total, exportParams: params });
      await this.loadAmounts(payload)
      await this.getGenerateInvoiceVisibility()
      return resolve(response)
    })
  }

  loadAmounts = async (params) => {
    let totalAmount = await Request.getIncentiveAmounts(params)
    this.setState({
      walletAmount: totalAmount.incentiveAmount ? totalAmount.incentiveAmount : 0.0,
      approvedAmount:totalAmount.approvedAmount ? totalAmount.approvedAmount :0.0,
      disburseAmount: totalAmount.disburseIncentiveAmount ? totalAmount.disburseIncentiveAmount : 0.0,
      paidAmount: totalAmount.paidAmount ? totalAmount.paidAmount : 0.0,
      rejectedAmount: totalAmount.rejectedAmount ? totalAmount.rejectedAmount : 0.0,
      invoiceUnderReviewedAmount: totalAmount.underReview ? totalAmount.underReview : 0.0
    })
  }

  loadCountry() {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth(params)
      .then((resp) => {
        if (resp) {
          let temp = [];
          _.each(resp.data, (vv) => {
            temp.push({
              text: vv.countryName,
              value: vv._id,
            });
          });
          this.setState({ countryArr: temp });
        }
      })
      .catch((err) => { });
  }

  loadInvoiceUsers = () => {
    Request.loadWalletInvoiceUsers({})
      .then((resp) => {
        let temp = [];
        _.each(resp, (vv) => {
          temp.push({
            text: vv.name,
            value: vv._id,
          });
        });
        this.setState({ invoiceUsers: temp });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  loadUsers = () => {
    Request.loadWalletUsers({})
      .then((resp) => {
        let temp = [];
        _.each(resp, (vv) => {
          temp.push({
            text: vv.name,
            value: vv._id,
          });
        });
        delete temp[0];

        this.setState({ users: temp });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  loadUniversities = () => {
    Request.loadUniversities({})
      .then((resp) => {
        let temp = [];
        _.each(resp, (vv) => {
          temp.push({
            text: vv.universityInstitutionName,
            value: vv._id,
          });
        });

        this.setState({ universities: temp });
      })
      .catch((err) => {
        console.log(err);
      });
  };


  handleDelete = async (record) => {
    let response = await Request.deleteIncentive(record)
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.reload();
  }

  renderStatus = (val) => {
    if (val === "VISA_UNDER_PROCESSING") {
      return "Visa Under Processing";
    }
    if (val === "VISA_APPROVED") {
      return "Visa Approved";
    }

    if (val === "VISA_REJECTED") {
      return "Visa rejected";
    }

    if (val === "INVOICE_UNDER_REVIEWED") {
      return "Invocie Under Reviewed";
    }

    if (val === "INVOICE_PAYMENT_DESK") {
      return "Invoice Payment Desk";
    }

    if (val === "INVOICE_PAID") {
      return "Invoice Paid";
    }
  };

  renderStageType = (val) => {
    if (val === "TELECALLER") {
      return "Telecaller";
    } else if (val === "COUNSELLING") {
      return "Counselling";
    } else if (val === "ADMISSION") {
      return "Admission";
    } else if (val === "VISAFILE") {
      return "Visa File";
    } else if (val === "VISAAPPROVED") {
      return "Visa Approved";
    }
  };

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          key: "createdByUser.time",
          from: date[0],
          to: date[1],
        },
      },
      () => {
        if (date[0] == undefined) {
          this.reload();
        }
      }
    );
  };

  onOk = (value) => {
    this.reload();
  };

  reload = () => {
    this.table.current.reload();
  };

  generateInvoice = async () => {
    this.setState({ loading: true });
    let x = await Request.generateInvoiceIncentive();
    this.setState({ loading: false, hideInvoiceButton: true });
    this.reload();
    notification.success({
      message: "Success",
      description: x.msg,
    });
  };
  getPendingIncentiveInvoice = async () => {
    this.setState({ loading: true });
    let x = await Request.generatePendingIncentiveInvoice()
    this.setState({ loading: false, hideInvoiceButton: true });
    this.reload();
    notification.success({
      message: "Success",
      description: x.msg,
    });
  };

  approveInvoice = async (data) => {
    this.setState({ loading: true });
    let x = await Request.approveInvoice(data);
    this.setState({ loading: false });
    this.reload();
    notification.success({
      message: "Success",
      description: x.msg,
    });
  };

  onUserChoose = (userId) => {
    this.setState({ userId: userId }, () => {
      this.table.current.reload();
    });
  };

  onUniversityChoose = (universityId) => {
    this.setState({ universityId: universityId }, () => {
      this.table.current.reload();
    });
  };

  onIncentiveChoose = (walletId) => {
    this.setState({ walletId }, () => {
      this.table.current.reload();
    });
  };

  setRowColor = (item) => {
    if (item.color == "green") return styles.applyGreen;
    else if (item.color == "red") return styles.applyRed;
  };

  getFinanceRecordsByStatus = (status) => {
    this.setState({ financeStatus: status }, () => {
      this.table.current.reload();
    });
  };

  returnDeskName = (val) => {
    const deskConfig = Settings.allDesks;

    let findIn = lodash.find(deskConfig, (rr) => {
      return rr.name == val;
    });

    if (findIn) {
      return (
        <div
          style={{
            backgroundColor: findIn.color,
            color: "white",
            padding: 3,
            display: "inline-block",
            fontWeight: "bold",
          }}
        >
          {Settings.deskNameObj[val]}
        </div>
      );
    } else {
      return <div>{val}</div>;
    }
  };

  getGenerateInvoiceVisibility = async () => {
    let { monthArrayForInvoice, disburseAmount, disburseI, localUser } = this.state
    let params = {
      userId: localUser._id,
      time: moment()
    }
    let response = await Request.getIncentiveInvoices(params)
    if(response && response.total>0) {
      this.setState({ hideInvoiceButton: true })
      return
    }else if(monthArrayForInvoice.includes(new Date().getMonth()) && (disburseAmount !== 0) ) {
      this.setState({hideInvoiceButton: false});
      return
    }else {
      this.setState({hideInvoiceButton: true});
      return
    }
  };

  columns = [
    {
      title: 'S No.',
      key: 'serialNumber',
      width: 60,
      fixed: true,
      render: (text, record, index) => {
          return (
              <span>{index + 1}</span>
          )
      }
    },
    {
      title: "User Name",
      key: "userName",
      dataIndex: "userId.name",
      searchTextName: "userName",
      filterRegex: true,
      width: 100,
    },
    {
      title: "ID",
      key: "studentId",
      dataIndex: "studentId",
      searchTextName: "studentId",
      filterRegex: true,
      width: 80,
      searchTextName: "studentId",
      filterRegex: true,
      render: (text, record) => {
        if (record.visaId) {
          return (
            <div>{record.visaId}</div>
          )
        } else {
          return (
            <div>{text}</div>
          )
        }
      }
    },
    {
      title: "Student Name",
      key: "studentName",
      dataIndex: "inquiryId.studentName",
      searchTextName: "studentName",
      filterRegex: true,
      width: 100,
      render: (text, record) => {
        if (record.visaInquiryId) {
          return (
            <div>{record.visaInquiryId.applicantName}</div>
          )
        } else {
          return (
            <div>{text}</div>
          )
        }
      }
    },
    {
      title: "Country",
      key: "countryName",
      dataIndex: "countryId.countryName",
      width: 90,
      searchTextName: "countryName",
    },
    {
      title: "University Name",
      key: "universityId.universityInstitutionName",
      dataIndex: "universityId.universityInstitutionName",
      width: 130,
      render: (text, record) => {
        if (record.universityId) {
          return (<div>{text}</div>)
        } else {
          return (
            <div>N/A</div>
          )
        }
      }
    },
    {
      title:'Type',
      key:'type',
      dataIndex:'type',
      width:120,
      filters: ["Regular", "Previous"].map((x) => ({
        value: x,
        text: x,
      })),
      render:(text,record) =>(
        record.type?record.type:'Regular'
      )
    },
    {
      title: "Channel Partner",
      key: "channelPartnerName",
      dataIndex: "channelPartnerName",
      searchTextName: "channelPartnerName",
      filterRegex: true,
      width: 130,
      render: (text, record) => {
        if (record.channelPartnerName) {
          return (<div>{text}</div>)
        } else {
          return (<div>N/A</div>)
        }
      }
    },
    {
      title: "Incentive Amount",
      key: "incentiveAmount",
      dataIndex: "incentiveAmount",
      width: 100,
      hiddenForFinance: true,
    },
    {
      title: "Incentive Type",
      key: "incentiveFor",
      dataIndex: "incentiveFor",
      width: 100,
      filters:
        this.state.stagestypeArr &&
        this.state.stagestypeArr.map((x) => ({
          value: x.id,
          text: x.display,
        })),
      // render: (val) => (val ? incentiveType[val] : ""),
    },
    {
      title: "Desk",
      key: "atLevel",
      dataIndex: "inquiryId.atLevel",
      width: 100,
      // filters:
      //   this.state.atLevels &&
      //   this.state.atLevels.map((x) => ({ value: x.value, text: x.name })),
      render: (val, record) => {
        if (record.inquiryId) {
          return (<div>{record.inquiryId.atLevel}</div>)
        } else {
          return (<div>N/A</div>)
        }
        // return this.returnDeskName(val);
      },
    },
    {
      title:'Visa Approval Date',
      key:'visaDesk.visaApprovalDate',
      dataIndex:'visaDesk.visaApprovalDate',
      width:100,
      render:(text,record) => (
        <div>{record && record.inquiryId && record.inquiryId.visaDesk && record.inquiryId.visaDesk.visaApprovalDate?moment(record.inquiryId.visaDesk.visaApprovalDate).format('YYYY-MM-DD'):"NA"}</div>
      )
    },
    {
      title: "Inquiry Type",
      key: "inquiryType",
      dataIndex: "inquiryType",
      width: 100,
      filters:
        this.state.inquiryType &&
        this.state.inquiryType.map((x) => ({ value: x.id, text: x.display })),
      // render: (val, record) => {
      //   return this.renderStageType(val);
      // },
    },
    {
      title: "Incentive Status",
      key: "status",
      dataIndex: "status",
      width: 160,
      filters: this.searchParams.get("id")
        ? []
        : this.state.statusArr &&
        this.state.statusArr.map((x) => ({ value: x.id, text: x.display })),
      // render: (val, record) => {
      //   return this.renderStatus(val);
      // },
    },
    {
      title: "Created At",
      width: 150,
      key: "createdByUser",
      dataIndex: "createdByUser",
      render: (text, record) => {
        return (
          <div>
            <small>{text ? moment(text.time).format("lll") : ""}</small>
          </div>
        );
      },
    },
    {
      title: "Remarks",
      width: 150,
      key: "reason",
      dataIndex: "reason",
      render: (text, record) => (
        <span style={{ color: 'red' }}>{text}</span>
      )
    },
    {
      title: "Action",
      key: "operation",
      width: 150,
      dataIndex: "operation",
      render: (text, record) => {
        return (
          <React.Fragment>
            {
              record.status !== "Paid"?
              <RightsWrapper myRight={"IncentiveDesk.delete"}>
                <Tooltip title="Delete Incentive">
                  <Popconfirm
                    title="Are you sure to delete?"
                    onConfirm={() => this.handleDelete(record)}>
                    <Button
                      size={"small"}
                      shape="circle"
                      icon="cross"
                    />
                  </Popconfirm>
                </Tooltip>
              </RightsWrapper>
              
              :null
            }
          </React.Fragment>
        )
      }
    },
  ];

  financeExtraDDColumns = [
    {
      title: "Action",
      key: "operation",
      dataindex: "operation",
      width: 80,
      render: (text, record) => {
        return (
          <React.Fragment>
            <Button
              style={{
                backgroundColor: "#85CF4A",
                border: "1px solid #85CF4A",
                color: "white",
              }}
              size={"small"}
              onClick={() =>
                this.approveInvoice({
                  studentId: record.studentId,
                  id: record.id,
                })
              }
            >
              Approve
            </Button>
          </React.Fragment>
        );
      },
    },
  ];

  financeColumns = [
    {
      title: "Action",
      key: "operation",
      dataindex: "operation",
      width: 50,
      render: (text, record) => {
        return (
          <React.Fragment>
            <Tooltip title="View">
              <Button
                className={styles.btn}
                shape="circle"
                size={"small"}
                href={`/incentive_desk/view?id=${record.studentId}&status=${this.state.financeStatus === "INVOICE_PAYMENT_DESK"
                  ? "invoice payment desk"
                  : "invoice under review"
                  }`}
                icon="eye"
              />
            </Tooltip>{" "}
            <Popconfirm
              title="All Incentive of this student or visa will be approved?"
              onConfirm={() => {
                this.approveInvoice({ studentId: record.studentId });
              }}
              onCancel={() => {
                console.log();
              }}
              okText="Yes"
              cancelText="No"
              style={{
                display:
                  this.state.financeStatus === "INVOICE_PAYMENT_DESK"
                    ? "none"
                    : "block",
              }}
            >
              <Button
                style={{
                  backgroundColor: "#85CF4A",
                  border: "1px solid #85CF4A",
                  color: "white",
                  display:
                    this.state.financeStatus === "INVOICE_PAYMENT_DESK"
                      ? "none"
                      : "inline-block",
                }}
                size={"small"}
              >
                Approve
              </Button>
            </Popconfirm>
          </React.Fragment>
        );
      },
    },
    {
      title: "ID",
      key: "studentId",
      dataIndex: "studentId",
      searchTextName: "studentId",
      filterRegex: true,
      width: 80,
      searchTextName: "studentId",
      filterRegex: true,
    },
    {
      title: "Student Name",
      key: "studentName",
      dataIndex: "studentName",
      width: 100,
    },
    {
      title: "Country",
      key: "countryId",
      dataIndex: "countryName",
      width: 90,
      searchTextName: "countryName",
    },
    {
      title: "University Name",
      key: "universityInstitutionName",
      dataIndex: "universityInstitutionName",
      width: 130,
    },
  ];

  // asyncExportClick = async () => {
  //   await this.exportRef.current.link.click();
  // };


  exportExcelData = async () => {
    let { exportParams } = this.state
    if (!exportParams.status) {
      exportParams.status = "Approved"
    }
    exportParams.page = 1;
    exportParams.count = 10000000000;
    exportParams.results = 10000000000;
    let response = await Request.exportIncentiveInExcel(exportParams)
    if (!response.error) {
      window.open(response.url)
    }
  }

  getColumnView = () => {
    if (this.props.currentUser.userGroup === financeUserGroup) {
      if (
        this.state.isUserDDView &&
        this.searchParams.get("status") === "invoice payment desk"
      ) {
        return this.columns.filter((item) => !item.hiddenForFinance);
      }
      if (this.state.isUserDDView) {
        return [...this.financeExtraDDColumns, ...this.columns].filter(
          (item) => !item.hiddenForFinance
        );
      }
      return this.financeColumns;
    }
    return this.columns.filter((item) => !item.hiddenForOthers);
  };

  render() {
    // apicall is happening before redux loads, so have to check if store loaded.
    if (this.props.currentUser.email === null) {
      return null;
    }

    const csvHeaders = [
      {
        label: "User Name",
        key: "userName",
      },

      {
        label: "ID",
        key: "studentId",
      },
      {
        label: "Student Name",
        key: "studentName",
      },
      {
        label: "Country",
        key: "countryName",
      },
      {
        label: "University Name",
        key: "universityInstitutionName",
      },
      {
        label: "Channel Partner",
        key: "channelPartnerName",
      },
      {
        label: "Incentive Amount",
        key: "incentiveAmount",
      },
      {
        label: "Disburse Incentive Amount",
        key: "disburseIncentiveAmount",
      },
      {
        label: "Invoice Under Reviewed Amount",
        key: "invoiceUnderReviewedAmount",
      },
      {
        label: "Incentive Type",
        key: "incentiveType",
      },
      {
        label: "Desk",
        key: "desk",
      },
      {
        label: "Type",
        key: "stageType",
      },
      {
        label: "Status",
        key: "status",
      },
      {
        label: "Remarks",
        key: "reason",
      },
      {
        label: "Created At",
        key: "createdByUser",
      },
    ];

    const {
      users,
      universities,
      walletTypeArr,
      invoiceUsers,
      records,
    } = this.state;
    const isFinanceUser = this.props.currentUser.userGroup === financeUserGroup;
    return (
      <PageHeaderWrapper title={` INCENTIVE DESK : ${this.state.count} `}>
        <Card style={{ marginBottom: 10 }}>
          {!isFinanceUser ? (
            <Row style={{display:'flex', justifyContent:'space-between'}}>
              <Col span={11} style={{justifyContent:'space-between'}}>
                <Card>
                  <Row style={{display:'flex', justifyContent:'space-between', textAlign:'center'}}>
                  <Col span={5} style={{ marginTop: 4 }}>
                <h3>
                 {" "}
                  <span>Wallet<br></br> &#x20b9;  {this.state.walletAmount}</span>{" "}
                </h3>
                  </Col>
                  <Col span={9} style={{ marginTop: 4 }}>
                 <h3>
                   {" "}
                   <span>
                     Disburse Amount <br></br> &#x20b9; {this.state.disburseAmount}
                   </span>{" "}
                 </h3>
               </Col>
               <Col span={9 } style={{ marginTop: 4 }}>
                   <h3>
                     {" "}
                     <span>
                       Rejected Amount <br></br> &#x20b9;{" "}
                       {this.state.rejectedAmount}
                     </span>{" "}
                   </h3>
                 </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={11}>
              <Card>
                  <Row style={{display:'flex', justifyContent:'space-between', textAlign:'center'}}>
                  <Col span={11} style={{ marginTop: 4 }}>
                  <h3>
                     {" "}
                     <span>
                       Invoice Under Review <br></br> &#x20b9; {" "}
                       {this.state.invoiceUnderReviewedAmount}
                     </span>{" "}
                   </h3>
                  </Col>
                  <Col span={7} style={{ marginTop: 4 }}>
                  <h3>
                     {" "}
                     <span>Yet to be Paid <br></br> &#x20b9; {this.state.approvedAmount}</span>{" "}
                  </h3>
                  </Col>
                  <Col span={6} style={{ marginTop: 4 }}>
                  <h3>
                   {" "}
                   <span>
                     Paid <br></br> &#x20b9; {" "}
                     {this.state.paidAmount}
                   </span>{" "}
                 </h3>
                  </Col>
                    </Row>
                </Card>
              </Col>
            </Row>
            // <Row>
            //   <Col span={3} style={{ marginTop: 4 }}>
            //     <h3>
            //       <Icon type="wallet" style={{ fontSize: 20 }} />{" "}
            //       <span>Wallet : &#x20b9; {this.state.walletAmount}</span>{" "}
            //     </h3>
            //   </Col>
            //   <Col span={4} style={{ marginTop: 4 }}>
            //     <h3>
            //       <Icon type="wallet" style={{ fontSize: 20 }} />{" "}
            //       <span>Unpaid : &#x20b9; {this.state.approvedAmount}</span>{" "}
            //     </h3>
            //   </Col>
            //   <Col span={4} style={{ marginTop: 4 }}>
            //     <h3>
            //       <Icon type="wallet" style={{ fontSize: 20 }} />{" "}
            //       <span>
            //         Rejected Amount : &#x20b9;{" "}
            //         {this.state.rejectedAmount}
            //       </span>{" "}
            //     </h3>
            //   </Col>
            //   <Col span={5} style={{ marginTop: 4 }}>
            //     <h3>
            //       <Icon type="transaction" style={{ fontSize: 20 }} />{" "}
            //       <span>
            //         Disburse Amount : &#x20b9; {this.state.disburseAmount}
            //       </span>{" "}
            //     </h3>
            //   </Col>
            //   <Col span={3} style={{ marginTop: 4 }}>
            //     <h3>
            //       <Icon type="transaction" style={{ fontSize: 20 }} />{" "}
            //       <span>
            //         Paid : &#x20b9; {" "}
            //         {this.state.paidAmount}
            //       </span>{" "}
            //     </h3>
            //   </Col>
            //   <Col span={5} style={{ marginTop: 4 }}>
            //     <h3>
            //       <Icon type="transaction" style={{ fontSize: 20 }} />{" "}
            //       <span>
            //         Invoice Under Reviewed : &#x20b9; {" "}
            //         {this.state.invoiceUnderReviewedAmount}
            //       </span>{" "}
            //     </h3>
            //   </Col>
            // </Row>
          ) : null}

          <Row style={{ marginTop: 10 }}>
            {!isFinanceUser && (
              <RightsWrapper myRight={"IncentiveDesk.viewById"}>
                <Col span={3}>
                  <div>
                    <Button
                      type={"primary"}
                      className={styles.ledRed}
                      loading={this.state.loading}
                      hidden={this.state.hideInvoiceButton}
                      onClick={() => {
                        this.generateInvoice();
                      }}
                    >
                      Generate Invoice
                    </Button>
                  </div>
                </Col>
                <Col span={5}>
                  <div>
                    <Button
                      type={"primary"}
                      className={styles.ledRed}
                      loading={this.state.loading}
                      onClick={() => {
                        this.getPendingIncentiveInvoice();
                      }}
                    >
                      Generate Pending Invoice
                    </Button>
                  </div>
                </Col>
              </RightsWrapper>
            )}
            {(isFinanceUser && this.state.isUserDDView) || !isFinanceUser ? (
              <Col span={10}>
                <RangePicker
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD"
                  placeholder={["Start Date", "End Date"]}
                  onChange={this.chooseRangerPicker}
                  onOk={this.onOk}
                />
              </Col>
            ) : null}
            {isFinanceUser && (
              <Col span={4}>
                <Select
                  showSearch={true}
                  allowClear={true}
                  placeholder="Select User"
                  style={{ width: "150px", padding: "0 20px 0 20px" }}
                  className={"knowledge-base-input"}
                  onChange={this.onUserChoose}
                  filterOption={(input, option) => {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {invoiceUsers.map((item, key) => {
                    return (
                      <Option key={key} value={item.value}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            )}
            {!this.state.isUserDDView && (
              <RightsWrapper myRight={"IncentiveDesk.viewByBranch"}>
                <Col span={6}>
                  <Select
                    showSearch={true}
                    allowClear={true}
                    placeholder="Select User"
                    style={{ width: "280px", padding: "0 20px 0 20px" }}
                    className={"knowledge-base-input"}
                    onChange={this.onUserChoose}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {invoiceUsers.map((item, key) => {
                      return (
                        <Option key={key} value={item.value}>
                          {item.text}
                        </Option>
                      );
                    })}
                  </Select>
                </Col>
                <Col span={6}>
                  <Select
                    showSearch={true}
                    allowClear={true}
                    placeholder="Select Wallet"
                    style={{ width: "200px" }}
                    className={"knowledge-base-input"}
                    value={this.state.walletId}
                    onChange={this.onIncentiveChoose}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {walletTypeArr.map((item, key) => {
                      return (
                        <Option key={item.id} value={item.id}>
                          {item.display}
                        </Option>
                      );
                    })}
                  </Select>
                </Col>
              </RightsWrapper>
            )}
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col span={6}>
              <Button
                type={"default"}
                loading={this.state.loading}
                onClick={() => {
                  this.exportExcelData();
                }}
              >
                Export Excel
              </Button>
              {records && records.length > 0 && (
                <CSVLink
                  ref={this.exportRef}
                  asyncOnClick
                  data={records}
                  headers={csvHeaders}
                  filename={"incentive-desk.csv"}
                />
              )}
            </Col>
          </Row>
        </Card>

        <Card bordered={true}>
          <TableComp
            showSelector={true}
            columns={this.getColumnView()}
            ref={this.table}
            rowClassName={(record, index) => this.setRowColor(record)}
            apiRequest={(params) => this.apiIncentiveRequest(params)}
            extraProps={{ scroll: { x: 1500 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default (IncentiveDesk = connect(
  mapStateToProps,
  mapDispatchToProps
)(IncentiveDesk));
